import { observer } from "mobx-react-lite";
import Layout from "components/Layout";
import LaunchpadPage from 'components/Pages/launchpad';
import {Context,Util} from "@xt/xtbase";

const {XtAuth} = Context;
const {getOrigin} = Util;
import { get_tdk } from "api/server/tdk";

const Launchpad = () => {

  return (
    <Layout>
      <XtAuth
        renderLogin={()=>{
          return <LaunchpadPage />
        }}
        renderNotLogin={()=>{
          return <LaunchpadPage />
        }}
      />
    </Layout>
  );
};

export default observer(Launchpad);

export async function getStaticProps(context){
  const resolvedUrl = "/launchpad";
  const props = {resolvedUrl};
  try{
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      },
    });
    props.tdk = tdk || {};
  }
  catch(error)
  {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  console.log('props', props);
  return {
    props,
    revalidate:60
  }
}